<app-spinner id="spinner" [loading]="spinnerService.loading$ | async" />
<div id="reddi-history-screen">
  <app-header-bar
    [title]="_title"
    [dob]="_dob"
    [age]="_age"
    [showClientDetails]="false"
    [showButton]="false"
    (routerLinkClick)="routerLinkClicked()"
    *ngIf="_dob != undefined || _dob != null"
  />
  <!-- Client Information -->
  <div class="dashboard-side-card-container">
    <app-client-information
      id="client-information"
      subtitle=""
      [title]="_clientInformationTitle"
      [urlDisplayText]="_clientInformationDisplayText"
      [url]="_clientInformationUrl"
      [attributes]="_clientInformationAttributes"
      [isVertialOrientation]="true"
    />
  </div>
  <!-- Sub-Menu -->
  <app-sub-menu
    [clientId]="_clientId"
    [totalReviews]="_totalReviews"
    [flipHasAccess]="_hasAccess.flipHasAccess"
    [reddiHasAccess]="_hasAccess.reddiHasAccess"
    [slatHasAccess]="_hasAccess.slatHasAccess"
    [showBackButton]="true"
    (navigateBackClick)="previousRoute()"
  />
  <div id="graph-container">
    <app-primary-card size="full" height="1020" paddingSize="large">
      <div id="graph-header">
        <div id="header-title" class="mat-headline-2">
          {{ 'REDDI History' | translate }}
        </div>
        <app-action-toolbar
          [isEdit]="false"
          (editClick)="navigateTo('editReddi')"
          [isFullView]="false"
          (fullViewClick)="navigateTo('fullViewReddi')"
          [isHistory]="false"
          (historyClick)="navigateTo('historyReddi')"
          [isReport]="true"
          (reportClick)="navigateTo('reportReddi')"
          [isNew]="true"
          (newClick)="navigateTo('newReddi')"
        />
      </div>
      <app-reddi-graph [clientId]="_clientId" />
      <app-reddi-graph-legend [showTitle]="true"></app-reddi-graph-legend>
    </app-primary-card>
  </div>
  <div id="table-container">
    <app-primary-card size="full" height="750" paddingSize="large">
      <div id="table-header">
        <div id="header-title" class="mat-headline-2">
          {{ 'REDDI Entries' | translate }}
        </div>
        <app-action-toolbar
          [isEdit]="false"
          (editClick)="navigateTo('editReddi')"
          [isFullView]="false"
          (fullViewClick)="navigateTo('fullViewReddi')"
          [isHistory]="false"
          (historyClick)="navigateTo('historyReddi')"
          [isReport]="true"
          (reportClick)="navigateTo('reportReddi')"
          [isNew]="true"
          (newClick)="navigateTo('newReddi')"
        />
      </div>
      <app-table
        id="history-table"
        [dataSource]="_tableData"
        [columnsToDisplay]="_tableColumnsToDisplay"
        [columnDefinitions]="_tableColumnDefinitions"
        pageSize="12"
        kind="styled-header"
        showPager="true"
      />
    </app-primary-card>
  </div>
</div>
